<template>
  <my-giving-layout>
    <div class="bg-[#F6F4F0] w-full min-h-screen px-[24px] flex flex-col items-center text-center">
      <!-- Content container - vertically centered -->
      <div class="flex-1 flex flex-col items-center justify-center pb-[200px]">
        <img src="/assets/images/my-giving/rcsuccess.png" alt="Top Image" class="w-32 h-32 mb-4" />

        <div class="text-[2.25rem] leading-[2.5rem] font-black text-[#2B2926] tracking-[-0.03em]">
          Your application's on the way
        </div>
        <p class="mt-[16px]">
          Your bank is processing it now. <br />Check <b>Manage My Giving</b> in 2–3 days for the
          status.
        </p>
      </div>

      <div
        class="absolute bottom-[32px] mt-[32px] w-[90%] max-w-[600px] left-1/2 -translate-x-1/2 flex flex-col gap-[16px]"
      >
        <div
          @click="goToManageAccounts"
          class="border-[2px] border-[#42362B] w-full bg-[#F6F4F0] text-[#21201E] text-[1rem] md:text-[1.375rem] lg:text-[1.5rem] font-semibold rounded-[100px] py-[14px] md:py-[18px] lg:py-[20px] text-center"
        >
          See status
        </div>

        <BottomButton
          id="generate-qr-code"
          text="Back to MyGiving"
          :disabled="isButtonDisabled"
          :fontSize="16"
          @click="goToManageGiving"
          class="w-full mb-[0px]"
        />
      </div>
    </div>
  </my-giving-layout>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import MyGivingLayout from '@/components/MyGivingLayout.vue';
import { isNativeNotWeb } from '@/utils/platform-check';
import { Browser } from '@capacitor/browser';

export default {
  name: 'ApplicationInProgress',
  components: {
    BottomButton,
    MyGivingLayout,
  },
  data() {
    return {
      isButtonDisabled: false,
      isFromRecurringGiving: false,
    };
  },
  mounted() {
    this.isFromRecurringGiving =
      this.$route.query.fromrecurring === 'true' || this.$route.query.fromrecurring === true;
  },
  methods: {
    goToManageAccounts() {
      this.$router.push({ path: '/my-giving/manage', hash: '#accounts' });
    },
    goToManageGiving() {
      // If from recurring giving, navigate to manage recurring giving tab
      if (this.isFromRecurringGiving) {
        this.$router.push({ path: '/my-giving/manage', hash: '#recurring' });
      } else {
        this.$router.replace('/my-giving');
      }
    },
  },
  async ionViewWillEnter() {
    if (isNativeNotWeb()) {
      try {
        await Browser.close();
      } catch (error) {
        if (!error?.message?.includes('No active window')) {
          console.error('[ApplicationInProgress] Error closing browser:', error);
        }
      }
    }
  },
};
</script>
